import React, { useState, useRef } from 'react';
import CallBackRequestModal from './CallBackRequestModal/CallBackRequestModal';
import microPhoneRequest from 'HELPDESK/CommonResources/images/microPhoneIcon.svg';
const CallBackRequest = ({ isActive, isDisabled, onClick }) => {
    const [showTooltip, setShowTooltip] = useState(false);

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const toggleButtonRef = useRef(null);




    const togglePopup = () => {
        onClick?.();
        setIsPopupOpen(prev => !prev);
    };

    return (
        <>
            <div
                style={{
                    position: 'relative',
                    display: 'inline-block',

                }}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
            // ref={toggleButtonRef}

            >
                {/* {showTooltip && (
                    <div
                        style={{
                            position: 'absolute',
                            bottom: '120%',        // place above instead of right
                            left: '50%',
                            transform: 'translateX(-50%)',
                            backgroundColor: 'black',
                            color: 'white',
                            padding: '6px 10px',
                            borderRadius: '5px',
                            fontSize: '12px',
                            whiteSpace: 'nowrap',
                            zIndex: 999,
                        }}
                    >
                        Call Back Request
                        <div
                            style={{
                                position: 'absolute',
                                top: '100%',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: 0,
                    height: 0,                                                                                                                                                                                                                                                                                                                      SLCw
                                borderLeft: '6px solid transparent',                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
                                borderRight: '6px solid transparent',
                                borderTop: '6px solid black', // arrow pointing down
                            }}
                        />
                    </div>
                )} */}
                <button
                    onClick={togglePopup}
                    style={{
                        color: 'white',
                        backgroundColor: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        opacity: isDisabled ? 0.4 : 1
                    }}
                >
                    <img title={'Click to connect with our team.'} src={microPhoneRequest} alt="video" style={{ width: 20, height: 20 }} />
                </button>
            </div>
            <CallBackRequestModal isOpen={isPopupOpen} onClose={() => togglePopup()} ignoreRef={toggleButtonRef} />

        </>
    );
};

export default CallBackRequest;